import React from "react";
import Icon from "../Icon";
import StatusBadge from "../StatusBadge";
import "./styles.scss";

export const BoxIntegration = ({ 
    logo, 
    name, 
    cnpj, 
    razaoSocial, 
    productCount, 
    status,
    isNewSupplier = false,
    onDetailsClick 
}) => {
    if (isNewSupplier) {
        return (
            <div className="box-integration new-supplier">
                <div className="new-supplier-icon">
                    <Icon name="new-integration" size={24} />
                </div>
                <h3>Novo fornecedor</h3>
                <p>Em breve novas integrações estarão disponíveis para você.</p>
            </div>
        );
    }

    return (
        <div className="box-integration">
            <div className="integration-header">
                <div className="logo-container">
                    {logo && <img src={logo} alt={`Logo ${name}`} />}
                </div>
                <StatusBadge status={status} />
            </div>
            
            <div className="integration-content">
                <h3 className="supplier-name">{name}</h3>
                <p className="cnpj">CNPJ: {cnpj}</p>
                <p className="razao-social">{razaoSocial}</p>
                
                <div className="products-info">
                    <div className={`products-icon`}>
                        <Icon name="box" size={16} color="#241D54" />
                    </div>
                    <span className="product-count">{productCount} produtos</span>
                </div>
            </div>
            
            <button 
                className={`btn-details btn-primary`}
                onClick={onDetailsClick}
            >
                Mais detalhes
            </button>
        </div>
    );
};

export default BoxIntegration;
